module.exports = __webpack_public_path__ + "static/media/misty.1f6cfa2b.png";